<template>
  <div>
    <app-breadcrumb title="Reports Settings"></app-breadcrumb>
    <v-container fluid grid-list-xl pa-0>
      <v-layout row wrap>
        <v-flex lg6 md6 sm6 xs12>
          <app-card :fillHeight="false">
            <div class="app-card-header primary-actions">
              <div class="heading-block">
                <h4 class="heading">Products Excel</h4>
              </div>
              <div class="actions-block">
                <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''}` + ' i-tooltip' + ' text-xs-center']">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn
                        color="primary"
                        flat
                        small
                        :ripple="false"
                        :disabled="!getProductExcel.availability"
                        @click="downloadProductsExcel"
                      >
                        <v-icon class="mr-1">icon-icon</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span v-if="!getProductExcel.availability && !getProductLoading">Currently this report is unavailable</span>
                  <span v-else>Download Excel</span>
                </v-tooltip>
              </div>
            </div>
            <v-progress-linear
              v-if="getProductLoading"
              :indeterminate="true"
              height="3"
              color="primary"
              class="progress-card" />
            <div class="card-body">
              <ul class="primary-list">
                <li>
                  <div>
                    Show delta
                  </div>
                  <div>
                    <i-switch
                      @change="updateProductOption($event, 'show_delta')"
                      :value="getProductExcel.items.show_delta"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show delta percentage
                  </div>
                  <div>
                    <i-switch
                      @change="updateProductOption($event, 'show_delta_percentage')"
                      :value="getProductExcel.items.show_delta_percentage"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show availability
                  </div>
                  <div>
                    <i-switch
                      @change="updateProductOption($event, 'show_availability')"
                      :value="getProductExcel.items.show_availability"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show price suggestion
                  </div>
                  <div>
                    <i-switch
                      @change="updateProductOption($event, 'show_price_suggestion')"
                      :value="getProductExcel.items.show_price_suggestion"
                    />
                  </div>
                </li>
                <!--<li>-->
                  <!--<div>-->
                    <!--Seller tracking-->
                  <!--</div>-->
                  <!--<div class="d-flex align-center justify-end">-->
                    <!--<transition name="slide-x-transition">-->
                      <!--<div v-if="getProductExcel.items.show_seller !== '0'" class="dropdown-filter-primary xs">-->
                        <!--<v-autocomplete-->
                          <!--v-model="getProductExcel.items.show_seller"-->
                          <!--:items="getTrackingSellers.items"-->
                          <!--:loading="product.sellerTracking.isLoading"-->
                          <!--:search-input.sync="product.sellerTracking.search"-->
                          <!--:ripple="false"-->
                          <!--background-color="rgba(48, 127, 255, 0.1)"-->
                          <!--hide-details-->
                          <!--hide-selected-->
                          <!--clear-icon-->
                          <!--cache-items-->
                          <!--append-icon="expand_more"-->
                          <!--item-text="name"-->
                          <!--item-value="id"-->
                          <!--label="Sellers"-->
                          <!--solo-->
                          <!--flat-->
                          <!--@change="updateSellers($event, 'show_seller')"-->
                        <!--&gt;-->
                          <!--<template v-slot:item="{ item }">-->
                            <!--<v-list-tile-content>-->
                              <!--<v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>-->
                            <!--</v-list-tile-content>-->
                          <!--</template>-->
                        <!--</v-autocomplete>-->
                      <!--</div>-->
                    <!--</transition>-->
                    <!--<div class="f-zero">-->
                      <!--<i-switch-->
                        <!--class="ml-4"-->
                        <!--@change="updateProductSellerTracking($event, 'show_seller')"-->
                        <!--:value="getProductExcel.items.show_seller"-->
                      <!--/>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</li>-->
                <li>
                  <div>
                    Show category tree
                  </div>
                  <div class="d-flex">
                    <transition name="slide-x-transition">
                      <template v-if="product.showCategoryTree.show">
                        <v-radio-group :value="getProductExcel.items.show_category_tree" @change="updateProductOptionCategoryTree($event, 'show_category_tree')" row class="i-v-radio-group line" hide-details>
                          <v-radio label="1 Level" :value="1" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                          <v-radio label="2 Levels" :value="2" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                          <v-radio label="3 Levels" :value="3" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                        </v-radio-group>
                      </template>
                    </transition>
                    <i-switch
                      class="ml-2"
                      v-model="product.showCategoryTree.show"
                      @change="updateProductOption($event, 'show_category_tree')"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show product variation
                  </div>
                  <div>
                    <i-switch
                      @change="updateProductOption($event, 'show_product_variation')"
                      :value="getProductExcel.items.show_product_variation"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show cost price
                  </div>
                  <div>
                    <i-switch
                      @change="updateProductOption($event, 'show_cost_price')"
                      :value="getProductExcel.items.show_cost_price"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </app-card>

          <app-card :fillHeight="false" class="mt-4">
            <v-form @submit.prevent="saveNewProduct()" ref="priceTracking" v-model="product.validForm">
              <div class="app-card-header primary-actions">
                <div class="heading-block">
                  <h4 class="heading">Add new price suggestion
                    <v-tooltip top max-width="300px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''}` + ' i-tooltip']">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="ml-1">help</v-icon>
                      </template>
                      <span>Inforder is build from the ground up with over 7 years of experience on what this industry needs. It is efficient and no data is wasted while crawling. This lets us reach from 20 up to 50 times faster renew for the entire data volume our clients are tracking.</span>
                    </v-tooltip>
                  </h4>
                </div>
                <div class="actions-block">
                  <v-btn
                    class="i-btn-primary fill-height"
                    color="success"
                    type="submit"
                    flat
                    small
                    :ripple="false"
                    :disabled="product.category.model === null && product.brand.model === null"
                  >
                    <v-icon class="mr-1">save</v-icon>Save
                  </v-btn>
                </div>
              </div>
              <div class="card-body">
                <ul class="primary-list">
                  <li>
                    <div>
                      Product Category
                    </div>
                    <div>
                      <div class="dropdown-filter-primary-group">
                        <div class="dropdown-filter-primary sm">
                          <v-autocomplete
                            ref="newPriceCategory"
                            v-model="product.category.model"
                            :items="getPriceTrackingCategories"
                            :loading="product.category.isLoading"
                            :search-input.sync="product.category.search"
                            :ripple="false"
                            background-color="rgba(48, 127, 255, 0.1)"
                            clearable
                            hide-details
                            cache-items
                            clear-icon
                            append-icon="expand_more"
                            item-text="name"
                            item-value="id"
                            label="Product Category"
                            solo
                            flat
                          >
                            <template v-slot:item="{ item }">
                              <v-list-tile-content>
                                <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      Product Brand
                    </div>
                    <div>
                      <div class="dropdown-filter-primary-group">
                        <div class="dropdown-filter-primary sm">
                          <v-autocomplete
                            v-model="product.brand.model"
                            :items="getPriceTrackingBrands"
                            :loading="product.brand.isLoading"
                            :search-input.sync="product.brand.search"
                            :ripple="false"
                            background-color="rgba(48, 127, 255, 0.1)"
                            clearable
                            hide-details
                            cache-items
                            clear-icon
                            append-icon="expand_more"
                            item-text="name"
                            item-value="id"
                            label="Product Brand"
                            solo
                            flat
                          >
                            <template v-slot:item="{ item }">
                              <v-list-tile-content>
                                <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      Price Suggestion
                    </div>
                    <div>
                      <div class="dropdown-filter-primary-group">
                        <div class="dropdown-filter-primary sm">
                          <v-text-field
                            v-model="product.price.model"
                            class="i-v-text-field-primary"
                            solo
                            flat
                            hide-details
                            placeholder="Price Suggestion"
                            validate-on-blur
                          >
                          </v-text-field>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </v-form>
          </app-card>

          <app-card :fillHeight="false" class="mt-4">
            <div class="app-card-header primary-actions">
              <div class="heading-block">
                <h4 class="heading">Price suggestion rules</h4>
              </div>
              <div class="actions-block">
                <div class="dropdown-filter-primary xs">
                  <v-autocomplete
                    :value="getProductExcel.items.show_seller"
                    :items="getTrackingSellers.items"
                    :loading="product.sellerTracking.isLoading"
                    :search-input.sync="product.sellerTracking.search"
                    :ripple="false"
                    background-color="rgba(48, 127, 255, 0.1)"
                    hide-details
                    hide-selected
                    clear-icon
                    cache-items
                    append-icon="expand_more"
                    item-text="name"
                    item-value="id"
                    label="Sellers"
                    solo
                    flat
                    @change="updateSellers($event, 'show_seller')"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-tile-content>
                        <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </div>
                <i-text-field
                  solo
                  type="text"
                  width="180px"
                  placeholder="Search ..."
                  :disabled="getPriceRules.loading || getPriceRules.noData"
                  v-model="product.list.search"
                />
                <v-btn
                  class="i-btn-primary fill-height"
                  color="success"
                  :disabled="!product.list.reordered || product.list.listIsEditing"
                  flat
                  small
                  :ripple="false"
                  @click="saveReportPriceRulesOrder()"
                >
                  <v-icon class="mr-1">save</v-icon>Save
                </v-btn>
              </div>
            </div>
            <div class="card-body pa-0">
              <v-progress-circular
                v-if="getPriceRules.loading && getPriceRules.items.length <= 0"
                :indeterminate="true"
                :size="75"
                height="3"
                color="primary"
                class="progress-circular" />
              <v-data-table
                v-if="!getPriceRules.noData"
                :headers="product.list.headers"
                :items="getPriceRules.items"
                :rows-per-page-items="product.list.rowsPerPageItems"
                :pagination.sync="product.list.pagination"
                :search="product.list.search"
                :hide-actions="getPriceRules.loading && getPriceRules.items.length <= 0"
                :hide-headers="getPriceRules.loading && getPriceRules.items.length <= 0"
                :loading="getPriceRules.loading && getPriceRules.items.length > 0"
                no-data-text=""
                ref="sortableTable"
                item-key="user_id"
                class="i-table"
              >
                <template v-slot:items="props">
                  <tr class="sortableRow" :key="itemKeyProducts(props.item)">
                    <td class="sortHandleTd">
                      <v-btn
                        icon
                        :disabled="product.list.listIsEditing"
                        :ripple="false"
                        class="sortHandle ma-0">
                        <v-icon>drag_handle</v-icon>
                      </v-btn>
                    </td>
                    <td class="order-td">{{ props.item.order }}</td>
                    <td class="category-td"><span>{{ props.item.category }}</span></td>
                    <td class="brand-td"><span>{{ props.item.brand }}</span></td>
                    <td class="price-td"><span class="editable-td">{{ props.item.value }}</span></td>
                    <td class="td-sm">
                      <v-btn
                        class="ma-0 pa-0 btn-table-action edit-editable-btn"
                        :disabled="product.list.listIsEditing"
                        color="primary"
                        flat
                        small
                        :ripple="false"
                        @click="editProduct($event, props.item.rule_id)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn
                        class="ma-0 pa-0 btn-table-action save-editable-btn d-none"
                        color="success"
                        flat
                        small
                        :ripple="false"
                        @click="saveEditedProduct($event, props.item.rule_id, props.item.category_id, props.item.brand_id, props.item.value)"
                      >
                        <v-icon>save</v-icon>
                      </v-btn>
                      <v-btn
                        class="ma-0 pa-0 btn-table-action"
                        :disabled="product.list.listIsEditing"
                        color="error"
                        flat
                        small
                        :ripple="false"
                        @click="deleteProduct($event, props.item.rule_id)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <i-no-data heading="Oops!" v-else />
            </div>
          </app-card>
        </v-flex>
        <v-flex lg6 md6 sm6 xs12>
          <app-card :fillHeight="false">
            <div class="app-card-header primary-actions">
              <div class="heading-block">
                <h4 class="heading">Sellers Excel</h4>
              </div>
              <div class="actions-block">
                <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''}` + ' i-tooltip' + ' text-xs-center']">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn
                        color="primary"
                        flat
                        small
                        :disabled="!getSellersExcel.availability"
                        :ripple="false"
                        @click="downloadSellersExcel"
                      >
                        <v-icon class="mr-1">icon-icon</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span v-if="!getSellersExcel.availability && !getSellerLoading">Currently this report is unavailable</span>
                  <span v-else>Download Excel</span>
                </v-tooltip>
              </div>
            </div>
            <v-progress-linear
              v-if="getSellerLoading"
              :indeterminate="true"
              height="3"
              color="primary"
              class="progress-card" />
            <div class="card-body">
              <ul class="primary-list">
                <li>
                  <div>
                    Show delta
                  </div>
                  <div>
                    <i-switch
                      @change="updateSellerExcelOption($event, 'show_delta')"
                      :value="getSellersExcel.items.show_delta"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show delta percentage
                  </div>
                  <div>
                    <i-switch
                      @change="updateSellerExcelOption($event, 'show_delta_percentage')"
                      :value="getSellersExcel.items.show_delta_percentage"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show availability
                  </div>
                  <div>
                    <i-switch
                      @change="updateSellerExcelOption($event, 'show_availability')"
                      :value="getSellersExcel.items.show_availability"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show category tree
                  </div>
                  <div class="d-flex">
                    <transition name="slide-x-transition">
                      <template v-if="seller.showCategoryTree.show">
                        <v-radio-group :value="getSellersExcel.items.show_category_tree" @change="updateSellerOptionCategoryTree($event, 'show_category_tree')" row class="i-v-radio-group line" hide-details>
                          <v-radio label="1 Level" :value="1" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                          <v-radio label="2 Levels" :value="2" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                          <v-radio label="3 Levels" :value="3" :ripple="false" color="primary" class="i-v-radio light"></v-radio>
                        </v-radio-group>
                      </template>
                    </transition>
                    <i-switch
                      class="ml-2"
                      v-model="seller.showCategoryTree.show"
                      @change="updateSellerExcelOption($event, 'show_category_tree')"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show product variation
                  </div>
                  <div>
                    <i-switch
                      @change="updateSellerExcelOption($event, 'show_product_variation')"
                      :value="getSellersExcel.items.show_product_variation"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show cheaper seller
                  </div>
                  <div>
                    <i-switch
                      @change="updateSellerExcelOption($event, 'show_cheapest_seller')"
                      :value="getSellersExcel.items.show_cheapest_seller"
                    />
                  </div>
                </li>
                <li>
                  <div>
                    Show cost price
                  </div>
                  <div>
                    <i-switch
                      @change="updateSellerExcelOption($event, 'show_cost_price')"
                      :value="getSellersExcel.items.show_cost_price"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </app-card>

          <app-card :fillHeight="false" class="mt-4">
            <div class="app-card-header primary-actions">
              <div class="heading-block">
                <h4 class="heading">Sellers column order</h4>
              </div>
              <div class="actions-block">
                <i-text-field
                  solo
                  type="text"
                  width="180px"
                  placeholder="Search ..."
                  :disabled="getSellers.loading || getSellers.items.length <= 0"
                  v-model="seller.list.search"
                />
                <v-btn
                  class="i-btn-primary fill-height"
                  color="success"
                  :disabled="!seller.list.reordered"
                  flat
                  small
                  :ripple="false"
                  @click="saveSellers()"
                >
                  <v-icon class="mr-1">save</v-icon>Save
                </v-btn>
              </div>
            </div>
            <div class="card-body pa-0">
              <v-progress-circular
                v-if="getSellers.loading && getSellers.items.length <= 0"
                :indeterminate="true"
                :size="75"
                height="3"
                color="primary"
                class="progress-circular" />
              <v-data-table
                v-if="(getSellers.loading && getSellers.items.length <= 0) || (!getSellers.noData)"
                :headers="seller.list.headers"
                :items="getSellers.items"
                :rows-per-page-items="seller.list.rowsPerPageItems"
                :pagination.sync="seller.list.pagination"
                :search="seller.list.search"
                :hide-actions="getSellers.loading && getSellers.items.length <= 0"
                :hide-headers="getSellers.loading && getSellers.items.length <= 0"
                :loading="getSellers.loading && getSellers.items.length > 0"
                no-data-text=""
                ref="sortableTableSellers"
                item-key="seller_id"
                class="i-table"
              >
                <template v-slot:items="props">
                  <tr class="sortableRow" :key="itemKeySellers(props.item)" :class="{'disabled-row': props.item.seller_enabled === 0, 'sortableRow' : props.item.seller_enabled === 1}">
                    <td class="sortHandleTd">
                      <v-btn icon :ripple="false" class="sortHandle ma-0" :disabled="props.item.seller_enabled === 0">
                        <v-icon>drag_handle</v-icon>
                      </v-btn>
                    </td>
                    <td>{{props.item.order}}</td>
                    <td>{{props.item.seller_name}}</td>
                    <td class="td-sm text-xs-center">
                      <v-btn
                        class="ma-0 pa-0 btn-table-action"
                        :color="props.item.seller_enabled === 1 ? 'success' : 'error'"
                        flat
                        small
                        :ripple="false"
                        @click="toggleSellerStatus($event, props.item.seller_id, props.item.seller_enabled)"
                      >
                        <v-icon v-if="props.item.seller_enabled === 1">visibility</v-icon>
                        <v-icon v-else>visibility</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <i-no-data heading="Oops!" v-else />
            </div>
          </app-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Save Toaster-->
    <notifications group="save" position="bottom right" :max="product.toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title">
            <img src="../assets/img/icons/success.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>

    <!--Delete Toaster-->
    <notifications group="delete" position="bottom right" :max="product.toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title danger">
            <img src="../assets/img/icons/cancel.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import Vue from 'vue'
import Sortable from 'sortablejs'
import VeeValidate from 'vee-validate'
import { AppUrl } from '@/assets/js/variables'

Vue.use(VeeValidate)
export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'ReportsSettings',
  data: () => ({
    product: {
      validForm: false,
      category: {
        isLoading: false,
        items: [],
        model: null,
        search: null
      },
      brand: {
        isLoading: false,
        items: [],
        model: null,
        search: null
      },
      price: {
        model: null
      },
      optionsUpdated: false,
      showDelta: false,
      showDeltaPercentage: false,
      showAvailability: false,
      showPriceSuggestion: false,
      sellerTracking: {
        show: false,
        isLoading: false,
        items: [],
        model: 0,
        search: null
      },
      showCategoryTree: {
        show: false
      },
      showProductVariation: false,
      list: {
        itemKeys: new WeakMap(),
        currentItemKey: 0,
        reordered: false,
        search: '',
        headers: [
          { text: null, value: null, sortable: false },
          { text: 'Order', value: 'order', sortable: false },
          { text: 'Product Category', value: 'category', sortable: false },
          { text: 'Product Brand', value: 'brand', sortable: false },
          { text: 'Price Suggestion', value: 'price', sortable: false },
          { text: 'Edit/Delete', value: null, sortable: false }
        ],
        listIsEditing: false,
        category: {
          isLoading: false,
          items: [],
          model: 0,
          search: null
        },
        brand: {
          isLoading: false,
          items: [],
          model: 0,
          search: null
        },
        rowsPerPageItems: [10, 25, 50, 100],
        pagination: {
          rowsPerPage: 25
        },
        selected: []
      },
      toaster: {
        max: 3
      }
    },
    seller: {
      showDelta: false,
      showDeltaPercentage: false,
      showAvailability: false,
      showCategoryTree: {
        show: false
      },
      showProductVariation: false,
      list: {
        itemKeys: new WeakMap(),
        currentItemKey: 0,
        reordered: false,
        search: '',
        headers: [
          { text: null, value: null, sortable: false },
          { text: 'Order', value: 'id', sortable: false },
          { text: 'Name', value: 'seller_name', sortable: false },
          { text: 'Toggle status', value: 'enable_disable', sortable: false }
        ],
        rowsPerPageItems: [10, 25, 50, 100],
        pagination: {
          rowsPerPage: 25
        },
        selected: []
      }
    },
    timer: 1,
    fakeData: {
      items: [
        { rule_id: 64, category: 'Computer & Multimedia', brand: 'Projecta', value: '19.00', order: 1, category_id: 3, brand_id: 398 },
        { rule_id: 64, category: 'Computer & Multimedia', brand: 'Projecta', value: '19.00', order: 1, category_id: 3, brand_id: 398 },
        { rule_id: 64, category: 'Computer & Multimedia', brand: 'Projecta', value: '19.00', order: 1, category_id: 3, brand_id: 398 },
        { rule_id: 64, category: 'Computer & Multimedia', brand: 'Projecta', value: '19.00', order: 1, category_id: 3, brand_id: 398 },
        { rule_id: 64, category: 'Computer & Multimedia', brand: 'Projecta', value: '19.00', order: 1, category_id: 3, brand_id: 398 }
      ]
    }
  }),
  mounted () {
    // this.$store.dispatch('reportSettingsModule/getPriceOptions')
    this.loadExcel(1)
    this.loadExcel(2)
    this.loadProducts()
    this.loadSellers()
    this.editableProductOptionSellerTracking()
    /* eslint-disable no-new */
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        animation: 150,
        easing: 'cubic-bezier(1, 0, 0, 1)',
        onEnd: this.dragReorderProducts
      }
    )
    /* eslint-disable no-new */
    new Sortable(
      this.$refs.sortableTableSellers.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        animation: 150,
        easing: 'cubic-bezier(1, 0, 0, 1)',
        onEnd: this.dragReorderSellers
      }
    )
  },
  methods: {
    downloadProductsExcel () {
      window.open(
        `${AppUrl}?task=getProductsExcel`,
        '_blank'
      )
    },
    downloadSellersExcel () {
      window.open(
        `${AppUrl}?task=getSellersExcel`,
        '_blank'
      )
    },
    loadExcel (reportType) {
      this.$store.dispatch('reportSettingsModule/getExcel', {reportType: reportType})
    },
    updateProductOption (value, property) {
      this.$store.dispatch('reportSettingsModule/updateExcelOption', {
        fieldName: property,
        fieldValue: value === true ? '1' : '0',
        reportType: 1
      }).then(() => {
        this.saveProductOption()
        this.loadExcel(1)
        // this.$store.dispatch('reportSettingsModule/getExcel', { reportType: 1 })
      })
    },
    updateProductSellerTracking (value, property) {
      console.log(value)
      this.$store.dispatch('reportSettingsModule/updateExcelOption', {
        fieldName: property,
        fieldValue: value === false ? '0' : '1',
        reportType: 1
      })
    },
    updateProductOptionCategoryTree (value, property) {
      this.$store.dispatch('reportSettingsModule/updateExcelOption', {
        fieldName: property,
        fieldValue: value,
        reportType: 1
      }).then(() => {
        this.saveProductOption()
        this.loadExcel(1)
        // this.$store.dispatch('reportSettingsModule/getExcel', { reportType: 1 })
      })
    },
    updateSellerOptionCategoryTree (value, property) {
      this.$store.dispatch('reportSettingsModule/updateExcelOption', {
        fieldName: property,
        fieldValue: value,
        reportType: 2
      }).then(() => {
        this.saveExcelOption()
        this.loadExcel(2)
        // this.$store.dispatch('reportSettingsModule/getExcel', { reportType: 1 })
      })
    },
    updateSellers (value, property) {
      this.$store.dispatch('reportSettingsModule/updateExcelOption', {
        fieldName: property,
        fieldValue: value,
        reportType: 1
      }).then(() => {
        this.saveProductOption()
        this.loadExcel(1)
        // this.$store.dispatch('reportSettingsModule/getExcel', { reportType: 1 })
      })
    },
    editableProductOptionSellerTracking () {
      if (this.getProductExcel.items.show_seller !== 0) {
        this.$store.dispatch('reportSettingsModule/getSellerTracking', {
          sellerName: '',
          pageId: 'reports'
        }).then(() => {
          this.product.sellerTracking.isLoading = false
        })
      }
    },
    updateSellerExcelOption (value, property) {
      this.$store.dispatch('reportSettingsModule/updateExcelOption', {
        fieldName: property,
        fieldValue: value === true ? '1' : '0',
        reportType: 2
      }).then(() => {
        this.saveExcelOption()
        this.loadExcel(2)
        // this.$store.dispatch('reportSettingsModule/getExcel', { reportType: 2 })
      })
    },
    saveProductOption () {
      this.$notify({
        group: 'save',
        title: 'Product Excel',
        text: 'Option Saved !',
        duration: 500,
        speed: 600
      })
    },
    saveExcelOption () {
      this.$notify({
        group: 'save',
        title: 'Seller Excel',
        text: 'Option Saved !',
        duration: 500,
        speed: 600
      })
    },
    loadProducts () {
      this.$store.dispatch('reportSettingsModule/getPriceRules')
    },
    saveNewProduct () {
      if (this.$refs.priceTracking.validate()) {
        this.snackbar = true
        if (this.product.validForm === true) {
          this.$store.dispatch('reportSettingsModule/savePriceRule', {
            categoryId: this.product.category.model,
            brandId: this.product.brand.model,
            priceValue: this.product.price.model,
            ruleId: 0
          }).then(() => {
            this.$notify({
              group: 'save',
              title: 'New Product',
              text: 'New Product Save !',
              duration: 500,
              speed: 600
            })
            this.loadProducts()
            this.resetPriceSuggestion()
          })
        }
      }
    },
    editProduct (e, id) {
      const itemIndex = this.getPriceRules.items.findIndex(el => el.rule_id === id)
      const editableRows = this.$refs.sortableTable.$el.querySelector('tbody')
      const editableItem = editableRows.children[itemIndex]
      const editableSaveBtn = editableRows.children[itemIndex].querySelector('.save-editable-btn')
      const editableEditBtn = editableRows.children[itemIndex].querySelector('.edit-editable-btn')
      editableItem.classList.add('editable-td')
      setTimeout(() => {
        editableSaveBtn.classList.remove('d-none')
        editableEditBtn.classList.add('d-none')
      }, 0);
      [].slice.call(Array.from(editableItem.querySelectorAll('.editable-td'))).map((el) => {
        el.setAttribute('contenteditable', true)
      })
      this.product.list.listIsEditing = true
    },
    saveEditedProduct (e, id, categoryId, brandId, oldPriceValue) {
      if (this.product.list.reordered) {
        this.saveReportPriceRulesOrder()
      }
      this.product.list.listIsEditing = false
      this.product.list.listEditingItemId = null
      const itemIndex = this.getPriceRules.items.findIndex(el => el.rule_id === id)
      const editableRows = this.$refs.sortableTable.$el.querySelector('tbody')
      const editableItem = editableRows.children[itemIndex]
      const editableSaveBtn = editableRows.children[itemIndex].querySelector('.save-editable-btn')
      const editableEditBtn = editableRows.children[itemIndex].querySelector('.edit-editable-btn')
      editableItem.classList.remove('editable-td')
      editableEditBtn.classList.remove('d-none')
      editableSaveBtn.classList.add('d-none');
      [].slice.call(Array.from(editableItem.querySelectorAll('.editable-td'))).map((el) => {
        el.removeAttribute('contenteditable')
      })
      const newPriceValue = editableItem.querySelector('.price-td .editable-td').innerHTML
      if (oldPriceValue !== newPriceValue) {
        this.$store.dispatch('reportSettingsModule/savePriceRule', {
          categoryId: categoryId,
          brandId: brandId,
          priceValue: newPriceValue,
          ruleId: id
        }).then(() => {
          this.$notify({
            group: 'save',
            title: 'Price Suggestion',
            text: 'Price Suggestion Edited !',
            duration: 500,
            speed: 600
          })
        })
      }
    },
    deleteProduct (e, id) {
      this.$store.dispatch('reportSettingsModule/deleteProduct', {
        ruleId: id
      }).then(() => {
        this.$notify({
          group: 'delete',
          title: 'Product Deleted',
          text: 'Product Deleted !',
          duration: 500,
          speed: 600
        })
        this.loadProducts()
      })
    },
    saveReportPriceRulesOrder () {
      this.$store.dispatch('reportSettingsModule/saveReportPriceRulesOrder', {orderIds: this.getProductOrderIds()}).then(() => {
        this.loadProducts()
        this.product.list.reordered = false
        this.$notify({
          group: 'save',
          title: 'Products Reordered',
          text: 'Reordered Products Saved !',
          duration: 500,
          speed: 600
        })
      })
    },
    getProductOrderIds () {
      return this.getPriceRules.items.map(e => Number(e.rule_id))
    },
    loadSellers () {
      this.$store.dispatch('reportSettingsModule/getSellers')
    },
    toggleSellerStatus (e, id, status) {
      this.seller.list.reordered = true
      this.$store.commit('reportSettingsModule/SET_sellerEnabled', {
        id: id,
        status: status
      })
    },
    saveSellers () {
      this.$store.dispatch('reportSettingsModule/saveSellers', {
        sellers: this.getSellers.items
      }).then(() => {
        this.loadSellers()
        this.seller.list.reordered = false
        this.$notify({
          group: 'save',
          title: 'Sellers Reordered',
          text: 'Sellers Saved !',
          duration: 500,
          speed: 600
        })
      })
    },
    dragReorderProducts ({oldIndex, newIndex}) {
      this.$store.commit('reportSettingsModule/SET_mutatePriceRules', {
        oldIndex: oldIndex,
        newIndex: newIndex
      })
      this.product.list.reordered = true
    },
    itemKeyProducts (item) {
      if (!this.product.list.itemKeys.has(item)) this.product.list.itemKeys.set(item, ++this.product.list.currentItemKey)
      return this.product.list.itemKeys.get(item)
    },
    itemKeySellers (item) {
      if (!this.seller.list.itemKeys.has(item)) this.seller.list.itemKeys.set(item, ++this.seller.list.currentItemKey)
      return this.seller.list.itemKeys.get(item)
    },
    dragReorderSellers ({oldIndex, newIndex}) {
      this.$store.commit('reportSettingsModule/SET_mutateSellers', {
        oldIndex: oldIndex,
        newIndex: newIndex
      })
      this.seller.list.reordered = true
    },
    resetPriceSuggestion () {
      this.product.category.model = 1
      this.$refs.priceTracking.reset()
    }
  },
  computed: {
    getProductExcel () {
      return this.$store.state.reportSettingsModule.productExcel
    },
    getProductLoading () {
      return this.$store.state.reportSettingsModule.productLoading
    },
    getSellerLoading () {
      return this.$store.state.reportSettingsModule.sellerLoading
    },
    getSellersExcel () {
      return this.$store.state.reportSettingsModule.sellersExcel
    },
    getPriceTrackingCategories () {
      return this.$store.state.reportSettingsModule.priceTracking.categories
    },
    getPriceTrackingBrands () {
      return this.$store.state.reportSettingsModule.priceTracking.brands
    },
    getPriceRules () {
      return this.$store.state.reportSettingsModule.priceRules
    },
    getSellers () {
      return this.$store.state.reportSettingsModule.sellers
    },
    getTrackingSellers () {
      return this.$store.state.reportSettingsModule.trackingSellers
    },
    // Theme Color Scheme
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  },
  watch: {
    'getProductExcel.items.show_category_tree': function (val) {
      if (val > 0) {
        this.product.showCategoryTree.show = true
      } else {
        this.product.showCategoryTree.show = false
      }
    },
    'getSellersExcel.items.show_category_tree': function (val) {
      if (val > 0) {
        this.seller.showCategoryTree.show = true
      } else {
        this.seller.showCategoryTree.show = false
      }
    },
    'product.sellerTracking.search': function (val) {
      if (val === '' || val === null) {
        this.product.sellerTracking.model = 0
        this.product.sellerTracking.items = []
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.product.sellerTracking.isLoading = true
        this.$store.dispatch('reportSettingsModule/getSellerTracking', {sellerName: val, pageId: 'reports'}).then(() => {
          this.product.sellerTracking.isLoading = false
        })
      }, 300)
    },
    'product.category.search': function (val) {
      if (val === '' || val === null) {
        this.product.category.model = 0
        this.product.category.items = []
        return
      }
      if (this.getPriceTrackingCategories) {
        if (this.getPriceTrackingCategories.find(el => val === el.name)) return
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.product.category.isLoading = true
        this.$store.dispatch('reportSettingsModule/getCategories', {categoryName: val, brandId: this.product.brand.model, pageId: 'reports'}).then(() => {
          this.product.category.isLoading = false
        })
      }, 300)
    },
    'product.brand.search': function (val) {
      if (val === '' || val === null) {
        this.product.brand.model = 0
        this.product.brand.items = []
        return
      }
      if (this.getPriceTrackingBrands) {
        if (this.getPriceTrackingBrands.find(el => val === el.name)) return
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.product.brand.isLoading = true
        this.$store.dispatch('reportSettingsModule/getBrands', {brandName: val, categoryId: this.product.category.model, pageId: 'reports'}).then(() => {
          this.product.brand.isLoading = false
        })
      }, 300)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/ReportsSettings.vue